import wixData from 'wix-data';
const collectionName = 'Structures';
const fieldToFilterByInCollection = 'tags';
 
$w.onReady(function () {
 
    setRepeatedItemsInRepeater();
    loadDataToRepeater();
 
    $w('#filtre').onChange((event) => {
        const selectedTags = $w('#filtre').value;
        loadDataToRepeater(selectedTags);
    })
});
 
function loadDataToRepeater(selectedCategories = []) {
 
    let dataQuery = wixData.query(collectionName);
 
    if (selectedCategories.length > 0) {
        dataQuery = dataQuery.hasSome(fieldToFilterByInCollection, selectedCategories);
    }
 
 
    dataQuery
        .find()
        .then(results => {
            const itemsReadyForRepeater = results.items;
            $w('#repeater1').data = itemsReadyForRepeater;
            const isRepeaterEmpty = itemsReadyForRepeater.length === 0
 
            if (isRepeaterEmpty) {
                $w('#noproduct').show();
            } else {
                $w('#noproduct').hide();
            }
        })
}
 
function setRepeatedItemsInRepeater() {
 
    $w('#repeater1').onItemReady(($item, itemData) => {
        $item('#titre').text =itemData.nom;
		$item('#materiaux').text =itemData.matriaux;
		$item('#details').text =itemData.detail;
		$item('#dimensions').text =itemData.dimensions;
		$item('#longueur').text =itemData.longueur;
        $item('#image').src = itemData.image;
        $item('#image').tooltip = itemData.title;
        $item('#prix').text = '€' + itemData.location;
    })
}
